// Available indicators grouped by category
export const availableIndicators = [
  {
    category: 'Maternal Health',
    value: 'maternal_mortality',
    text: 'Maternal Mortality Rate',
  },
  {
    category: 'Maternal Health',
    value: 'antenatal_care',
    text: 'Antenatal Care Coverage',
  },
  {
    category: 'Child Health',
    value: 'infant_mortality',
    text: 'Infant Mortality Rate',
  },
  {
    category: 'Child Health',
    value: 'under5_mortality',
    text: 'Under-5 Mortality Rate',
  },
  {
    category: 'Immunization',
    value: 'bcg_coverage',
    text: 'BCG Coverage',
  },
  {
    category: 'Immunization',
    value: 'dpt_coverage',
    text: 'DPT Coverage',
  },
];

// Available data sources
export const availableDataSources = [
  {
    value: 'nhmis',
    text: 'NHMIS-DHIS2',
  },
  {
    value: 'ndhs',
    text: 'NDHS',
  },
  {
    value: 'mics',
    text: 'MICS',
  },
];

// Available themes
export const themeOptions = [
  {
    value: 'default',
    text: 'Default Theme',
  },
  {
    value: 'dark',
    text: 'Dark Theme',
  },
  {
    value: 'light',
    text: 'Light Theme',
  },
];

// Default configuration
export const defaultConfig = {
  name: '',
  title: '',
  description: '',
  indicators: [],
  dataSources: [],
  sections: ['Indicator Overview', 'Indicator Comparison'],
  theme: {
    name: 'default',
    colors: {
      primary: '#007D53',
      secondary: '#348481',
      accent: '#FFB800',
      background: '#FFFFFF',
      text: '#2C3E50',
    },
  },
  defaultSettings: {
    initialIndicator: '',
    initialDataSource: '',
    showTableRelatedIndicator: true,
  },
};
